import { sortQuotedProductByPrice } from "@/features/onboarding/quotes/utils/sortQuotedProductByPrice"

export type ComparisonVariant = "trv" | "invoice"

/** Minimum relative saving (3%) to display the invoice comparison */
const INVOICE_MIN_RELATIVE_SAVING = 0.03
/** Minimum absolute saving (in cents) to display the invoice comparison */
const INVOICE_MIN_ABSOLUTE_SAVING = 2000

function isSavingSignificant(saving: number, annualAmount: number) {
    return (
        saving > annualAmount * INVOICE_MIN_RELATIVE_SAVING || saving > INVOICE_MIN_ABSOLUTE_SAVING
    )
}

export const isSignificantBySaving: Record<
    ComparisonVariant,
    (saving: number, annualAmount: number) => boolean
> = {
    trv: isSavingSignificant,
    invoice: isSavingSignificant,
}

export function computeInvoiceSavingResult(
    quotedProducts: {
        monthlyAmount: number
    }[],
    annualInvoiceAmount: number
) {
    const cheapestMonthly = quotedProducts.sort(sortQuotedProductByPrice)[0].monthlyAmount
    const yearlySaving = annualInvoiceAmount - cheapestMonthly * 12

    return {
        yearlySaving: Math.ceil(yearlySaving / 100),
        isSignificant: isSignificantBySaving["invoice"](yearlySaving, annualInvoiceAmount),
    }
}
